module.exports = __webpack_public_path__ + "static/media/15_2.13cf90dc.png";